var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bread.length)?_c('div',{staticClass:"breadcrumb-component"},[_c('a-breadcrumb',[_vm._l((_vm.bread),function(item){return [_c('a-breadcrumb-item',{key:item},[_vm._v(_vm._s(item))])]})],2)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }